<template>
    <div>
        <section class="xlrclh">
            <img class="top-img" src="./../assets/imgs/79/title-bg.png" alt="" />
            <div class="technological-process">
                <div class="zcjj">
                    <img class="top" style="height: 1.12rem" src="./../assets/imgs/xllh/rcgyysq_zcjj.png" alt="" />
                    <div class="content">
                        <div class="des">
                            为大力构建“人才+项目+科技+金融”的人力资源协同创新体系，引进培育与中国航空经济之都能级相匹配的人才队伍，加快建设“天府人才第一区”，让“空港双流”成为海内外优秀人才的向往之地、集聚之地、成功之都，全面夯实高质量建设中国航空经济之都人才支撑。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/79/title-1.png" alt="" />
                    <div class="content">
                        新引进的硕士研究生及以上学历的应届毕业生。
                    </div>
                </div>
                <div class="sscl">
                    <img class="top" src="./../assets/imgs/79/title-2.png" alt="" />
                    <div class="content">
                        <div class="des">
                            1.2021年1月1日后，区内企业新引进的取得硕士研究生及以上学历（或学位）应届毕业生。
                        </div>
                        <div class="des">
                            2.人才与企业签订3年以上劳动合同并缴纳社会保险（劳动合同签订单位与社会保险缴纳单位必须一致）。
                        </div>
                        <div class="des">
                            3.申请人应于就业满一年后的12个月内提出申请，逾期视为自动放弃申报资格。
                        </div>
                        <div class="des">
                            4.享受市级人才安家补贴的人才不再享受此项补贴。
                        </div>
                        <div class="des">
                            5.应届毕业生是指应该毕业的年份即将毕业或已经毕业的学生。高校毕业生从毕业之日起两年内称为择业期（从毕业证上面落款的日期开始计算），在择业期内的毕业生享受应届生的同等待遇。择业期内找到用人单位，且办理入职并签订劳动合同，且单位开始缴纳至少三险一金后，则应届毕业生身份结束。
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/79/title-3.png" alt="" />
                    <div class="content">
                        对区内企业新引进的硕士研究生及以上学历的应届毕业生，并与区内企业签订劳动合同3年以上、就业满1年的，给予人才一次性2.4万元安家补贴。企业年度最高申报额不超过100万元，申报员额由人才单位自行统筹。
                    </div>
                </div>

                <div class="sbcl">
                    <img class="top" src="./../assets/imgs/79/title-4.png" alt="" />
                    <div class="content">
                        <div class="des">
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">1</div>
                                个人/企业申报
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">2</div>
                                用人单位初核
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">3</div>
                                区人才服务中心受理
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">4</div>
                                业务主管部门审核
                            </div>
                            <div class="item">
                                <div class="line"></div>
                                <div class="dot">5</div>
                                区委人才办会议审议
                            </div>
                            <div class="item">
                                <div class="dot">6</div>
                                落实兑现
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sxcl">
                    <img class="top" src="./../assets/imgs/78/title-5.png" alt="" />
                    <div class="content" style="font-weight: bold;">
                        常年受理，季度兑现。
                    </div>
                </div>
                <div class="contact">
                    <img class="top" src="./../assets/imgs/78/title-6.png" alt="" />
                    <div class="content">
                        <div class="number">
                            <span class="label">政策咨询电话：</span>
                            <div>
                                <a href="tel:028-85811323">028-85811323</a>
                            </div>
                        </div>
                        <div class="unit">
                            <span class="label">责任单位：</span>
                            区人才服务中心
                        </div>
                    </div>
                </div>
                <div class="codes">
                    <img class="code" src="../assets/imgs/79/code.png" />
                    <img class="text" src="../assets/imgs/79/text.png" />
                </div>
            </div>
        </section>
        <!-- <call phone="028-83221725"></call> -->
    </div>
</template>

<script>
import call from "../components/call.vue";
export default {
    data() {
        return {};
    },

    components: {
        call,
    },

    mounted() { },

    methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/assets/public.scss";

.xlrclh {
    background-color: $base-back;

    .top-img {
        width: 7.26rem;
        height: 5.77rem;
    }

    .technological-process {
        transform: translateY(-1.8rem);

        .sscl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .title {
                    font-size: 0.36rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.22rem;
                    position: relative;
                }
            }
        }

        .zcjj {

            // background-color:#fff;
            .top {
                width: 6.68rem;
                height: 2.12rem;
            }

            .content {
                width: 6.68rem;
                background: #ffffff;
                margin: -0.45rem auto 0;
                padding: 0.1rem 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                line-height: 0.44rem;

                .title {
                    font-size: 0.34rem;
                    font-weight: bold;
                    color: #333333;
                    text-align: left;
                    line-height: 0.5rem;
                }

                .des {
                    font-size: 0.26rem;
                    color: #4e4e4e;
                    text-align: left;
                    margin-top: 0.16rem;
                }
            }
        }

        .sxcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #fff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                line-height: 0.44rem;

            }
        }

        .zccl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0.33rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;

                .des {
                    color: #4e4e4e;
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    margin-top: 0.8rem;
                    position: relative;
                    text-align: center;

                    .title {
                        position: absolute;
                        top: -0.5rem;
                        left: 50%;
                        transform: translateX(-50%);
                        width: 2.98rem;
                        height: 0.67rem;
                        line-height: 0.67rem;
                        display: flex;
                        justify-content: center;
                        align-content: center;
                        font-size: 0.32rem;
                        font-weight: bold;
                        color: #ffffff;
                        border-radius: 1rem;
                        background-color: #739bfe;
                    }
                }
            }
        }

        .sbcl {
            position: relative;
            margin-top: 0.22rem;

            .top {
                width: 7.03rem;
                height: 1.37rem;
                margin-left: -0.18rem;
            }

            .content {
                width: 6.85rem;
                background: #e8eeff;
                margin: -0.45rem auto 0;
                padding: 0 0.33rem 0.64rem 0.36rem;
                box-sizing: border-box;
                border-radius: 0rem 0rem 0.26rem 0.26rem;
                padding-top: 0.28rem;
                font-size: 0.26rem;
                font-weight: 500;
                text-align: left;
                color: #4e4e4e;
                font-size: 0.32rem;
                font-weight: bold;
                color: #3D5AA3;

                .des {
                    text-align: left;
                    background: #ffffff;
                    border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
                    padding: 0.35rem 0.23rem 0.3rem;
                    padding-top: 0.1rem;
                    margin-top: 0.2rem;
                    position: relative;


                    .item {
                        margin-top: 0.35rem;
                        box-sizing: border-box;
                        position: relative;
                        padding-left: 0.42rem;
                        display: flex;

                        .line {
                            position: absolute;
                            width: 0.02rem;
                            height: 135%;
                            border-left: 0.02rem dashed #739bfe;
                            left: 0.1rem;
                            top: 0.2rem;
                            z-index: 0;
                            //   background-color: #739bfe;
                        }

                        .dot {
                            width: 0.39rem;
                            height: 0.39rem;
                            background-color: #739bfe;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            font-size: 0.28rem;
                            color: #fff;
                            border-radius: 50%;
                            position: absolute;
                            left: -0.1rem;
                            top: 0;
                            z-index: 9999;
                        }
                    }
                }
            }
        }

        .codes {
            margin: 0 auto;
            margin-top: 0.25rem;
            width: 6.85rem;
            background: #fff;
            padding: 0.3rem;
            box-sizing: border-box;
            border-radius: 0.26rem;
            padding-top: 0.28rem;
            font-size: 0.26rem;
            font-weight: 500;
            color: #4e4e4e;
            display: flex;
            justify-content: space-between;
            align-items: center;

            .code {
                width: 1.94rem;
                height: 1.94rem;
            }

            .text {
                width: 4rem;
            }
        }
    }
}
</style>
